import React, { useMemo } from 'react';
import { useLocalization } from '@/Hooks';
import { ColumnInfo, ColumnType, DocumentTemplateRow } from '@/Types';
import { FormInput } from '@/Components/Controls/Input/FormInput';
import { Checkbox } from '@/Components/Controls/Checkbox/Checkbox';
import {
  documentPrintModalActions,
  SetCountCopy,
  SetIsSortWhenPrinting,
} from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { useDispatch } from 'react-redux';

export function useDocumentPrintTableColumnInfo() {
  const dispatch = useDispatch();

  const {
    modalWindows: {
      documentPrintModal: { Columns },
    },
  } = useLocalization();

  function onCountCopyChanged(row: DocumentTemplateRow, value: number) {
    const setCountCopy: SetCountCopy = {
      guid: row.guid,
      count: value,
    };
    dispatch(documentPrintModalActions.setCountCopy(setCountCopy));
  }

  function onIsSortChanged(row: DocumentTemplateRow, value: boolean) {
    const setIsSortWhenPrinting: SetIsSortWhenPrinting = {
      guid: row.guid,
      isSort: value,
    };
    dispatch(documentPrintModalActions.setIsSortWhenPrinting(setIsSortWhenPrinting));
  }

  return useMemo<ColumnInfo<DocumentTemplateRow>[]>(
    () => [
      {
        columnType: ColumnType.String,
        fieldName: 'countCopy',
        headerText: Columns.CountCopy,
        alignment: 'center',
        width: '80px',
        render: (rowData: DocumentTemplateRow) => (
          <FormInput
            name={'countCopy'}
            valueForSet={rowData.countCopy}
            type={'number'}
            min={1}
            max={10}
            onChange={(val) => {
              onCountCopyChanged(rowData, Number(val));
            }}
          />
        ),
      },
      {
        columnType: ColumnType.String,
        fieldName: 'name',
        alignment: 'left',
        headerText: Columns.Name,
      },
      {
        columnType: ColumnType.Boolean,
        fieldName: 'isSortWhenPrinting',
        alignment: 'center',
        width: '80px',
        headerText: Columns.Sorting,
        render: (rowData: DocumentTemplateRow) => (
          <Checkbox
            valueForSet={rowData.isSortWhenPrinting}
            visibility={rowData.countCopy > 1}
            onChange={(val) => {
              onIsSortChanged(rowData, val);
            }}
          />
        ),
      },
    ],
    [Columns],
  );
}
